import { render } from "./BranchForm.vue?vue&type=template&id=45cb90c0&scoped=true"
import script from "./BranchForm.vue?vue&type=script&lang=js"
export * from "./BranchForm.vue?vue&type=script&lang=js"

import "./BranchForm.vue?vue&type=style&index=0&id=45cb90c0&scoped=true&lang=css"
import "./BranchForm.vue?vue&type=style&index=1&id=45cb90c0&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cb90c0"]])

export default __exports__